import React, { Component, Suspense, lazy } from "react";
import ProductBase from './product-base.jsx';
import wishlist from '../../components/wishlist';
import toast from '../../components/toast';
import { postGetTranslations } from '../../apis/translations';
import { isProductInCart } from '../../apis/shopping-cart';
import { fetchShoppingCartTranslations } from '../services/TranslationService';

class Product extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isInWishlist: false,
            isLoadingWishlist: false,
            isInCart: false,
            translationLookup: {}, // Initialize as an empty object
            shoppingCartTranslations: null
        };

        this.handleWishlistClick = this.handleWishlistClick.bind(this);
    }

    componentDidMount() {
        fetchShoppingCartTranslations()
            .then(shoppingCartTranslations => {
                this.setState({ shoppingCartTranslations });
            })
            .catch(error => {
                console.log(error);
            });

        wishlist.hasProduct(this.props.skuNumber).then(result => this.setState({
            isInWishlist: result
        }));

        if (this.props.skuId) {
            isProductInCart(this.props.skuId).then(result => this.setState({
                isInCart: result
            })).catch(error => console.log(error));
        }

        // Define translation keys
        let translationKeys = {
            WhisListRemoved: 'ProductItem.Text.WhisListRemoved',
            WhisListRemovedError: 'ProductItem.Text.WhisListRemovedError',
            WhisListAdded: 'ProductItem.Text.WhisListAdded',
            WhisListAddedError: 'ProductItem.Text.WhisListAddedError',
            BtnAddWishList: 'ProductItem.Text.BtnAddWishList',
            FilterSearchMessage: 'Filters.Label.SearchMessage'
        };

        // Fetch translations and update state
        postGetTranslations([
            translationKeys.WhisListRemoved,
            translationKeys.WhisListRemovedError,
            translationKeys.WhisListAdded,
            translationKeys.WhisListAddedError,
            translationKeys.BtnAddWishList,
        ]).then(translations => {
            this.setState({
                translationLookup: {
                    WhisListRemoved: translations[translationKeys.WhisListRemoved] ?? 'Removed from your wish list',
                    WhisListRemovedError: translations[translationKeys.WhisListRemovedError] ?? 'There was an error trying to remove this product from your wish list',
                    WhisListAdded: translations[translationKeys.WhisListAdded] ?? 'Added to your wish list',
                    WhisListAddedError: translations[translationKeys.WhisListAddedError] ?? 'There was an error trying to add this product to your wish list',
                    BtnAddWishList: translations[translationKeys.BtnAddWishList] ?? 'Add to Wish List'
                }
            });
        }).catch(error => {
            console.log(error);
        });
    }

    handleWishlistClick(e) {
        wishlist.hasProduct(this.props.skuNumber).then(result => {
            this.setState({
                isInWishlist: result,
                isLoadingWishlist: true
            });
            if (result) {
                wishlist.delete(this.props.skuNumber)
                    .then(data => {
                        toast.success(this.state.translationLookup.WhisListAdded);
                        this.setState({
                            isInWishlist: false
                        });
                    })
                    .catch(error => {
                        toast.error( this.state.translationLookup.WhisListRemovedError );
                    })
                    .finally(() => {
                        this.setState({
                            isLoadingWishlist: false
                        });
                    });
            }
            else {
                wishlist.add(this.props.skuNumber)
                    .then(data => {
                        toast.success( this.state.translationLookup.WhisListAdded );
                        this.setState({
                            isInWishlist: true
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        toast.error(this.state.translationLookup.WhisListAddedError );
                    })
                    .finally(() => {
                        this.setState({
                            isLoadingWishlist: false
                        });
                    });
            }
        });
    }

    renderActionButton() {
        const actionType = this.props.actionType;
        const iconName = this.state.isInWishlist ? "icon-heart-filled" : "icon-heart";
        const btnLabel = this.state.translationLookup?.BtnAddWishList || 'Add to Wish List';

        switch (actionType) {
            case 'wishlist':
                return (
                    <button className="btn btn-outline-alt" type="button" onClick={this.handleWishlistClick} disabled={this.state.isLoadingWishlist}>
                        <svg className={`icon ${iconName}`}><use xlinkHref={`#${iconName}`}></use></svg>
                        <span>{btnLabel}</span>
                    </button>
                );
            case 'projectBuilder': {
                const QuickAddWrapper = lazy(() => import("../../../site-js/react/components/project-builder/quick-add-query-client.jsx"));
                return <Suspense><QuickAddWrapper item={this.props} /></Suspense>;
            }
            case 'callForPrice':
                return null;
            case 'cart': {
                const ShoppingCartActions = lazy(() => import("./shopping-cart-actions.jsx"));
                return (
                    <Suspense>
                        <ShoppingCartActions
                            authenticated={this.props.dealerPrice != null ? 'True' : 'False'}
                            isInStock={this.props.inventoryQuantity > 0 ? 'True' : 'False'}
                            inventory={this.props.inventoryQuantity}
                            sku={this.props.skuId}
                            itemNum={this.props.itemNumber}
                            inCart={this.state.isInCart ? 'True' : 'False'}
                            translations={this.state.shoppingCartTranslations}
                        />
                    </Suspense>
                );
            }
            default:
                return null;
        }
    }

    render() {
        const actions = (
            <div className="full-card-actions">
                {this.renderActionButton()}
            </div>
        );

        return (
            <>
                <ProductBase {...this.props} actions={actions} />
            </>
        );
    }
}

export default Product;